export class LiteTouch {
    constructor(socket, log) {
        this.socket = socket;
        this.power = false;
        this.videoSelection = '014'; // HDMI 1
        this.volume = 50;
        this.volumeMute = false;
        this.asyncHandlers = [
            {
                name: 'powerQuery',
                regExp: /k(\d{2})gi000/i,
                callback: (match) => {
                    this.socket.send(`${this.power ? 'Now ON' : 'Now Standby'}`);
                },
            },
            {
                name: 'powerSet',
                regExp: /k(\d{2})sA00(\d)/i,
                callback: (match) => {
                    this.power = match[2] === '1';
                    this.socket.send(`${this.power ? 'Power On' : 'Power Down'}`);
                },
            },
            {
                name: 'videoQuery',
                regExp: /k(\d{2})gh000/i,
                callback: (match) => {
                    this.socket.send(`k${match[1]}rh${this.videoSelection.padStart(3, '0')}`);
                },
            },
            {
                name: 'videoSet',
                regExp: /k(\d{2})sB(\d+)/i,
                callback: (match) => {
                    this.videoSelection = match[2] ? match[2] : '014';
                    this.socket.send(`k${match[1]}y`);
                },
            },
            {
                name: 'volumeQuery',
                regExp: /k(\d{2})gf000/i,
                callback: (match) => {
                    this.socket.send(`k${match[1]}rf${this.volume.toString().padStart(3, '0')}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /k(\d{2})sP(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        this.volume = parseInt(match[2], 10);
                        this.socket.send(`k${match[1]}y`);
                    }
                },
            },
            {
                name: 'volumeMuteQuery',
                regExp: /k(\d{2})gg000/i,
                callback: (match) => {
                    this.socket.send(`k${match[1]}rg00${this.volumeMute ? '1' : '0'}`);
                },
            },
            {
                name: 'volumeMuteSet',
                regExp: /k(\d{2})sQ00(\d+)/i,
                callback: (match) => {
                    if (match[2]) {
                        this.volumeMute = match[2] === '1';
                        this.socket.send(`k${match[1]}y`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`k01n`);
                },
            },
        ];
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            if (this.videoSelection === lowestCode)
                return;
            if (lowestCode === undefined ||
                parseInt(videoInput.code, 10) < parseInt(lowestCode, 10)) {
                lowestCode = videoInput.code;
            }
        }
        this.videoSelection = lowestCode !== null && lowestCode !== void 0 ? lowestCode : '014';
    }
}
LiteTouch.emulatorType = 'socketEmulator';
LiteTouch.key = '-Mj5HiqN-qv3fVyBhWGK';
